import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Providers/AuthProvider";
import { useFormik } from "formik";
import * as Yup from "yup";
import ConvertDate from "../../common/ConvertDate";
import { toast } from "react-toastify";
import UpdateTourFormSecondStep from "../UpdateTourForm/UpdateTourFormSecondStep";
import NaturePlanPriceList from "../NaturePlanPriceList/NaturePlanPriceList";
import { getNaturePlanPriceItemService } from "../../services/getNaturePlanPriceItem";
import SaveHikingTourPriceService from "../../services/SaveHikingTourPrice";
import "animate.css";
import TrackVisibility from "react-on-screen";
import Spinner from "../spinner/Spinner";
import Modal from "../Modal/Modal";
import ContentLoading from "../Loading/Loading";
import { goToTop } from "../../utiles/GotoTop";

const ManageTourThirdStep = ({ nextStepTab, prevStepTab }) => {
  const [submitTracker, setSubmitTracker] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const [tour, setTour] = useState({
    AdultPrice: "",
    ChildPrice: "",
    DateTime: "",
    Load: "",
    State: "",
    Description: "",
    CurrencyTypeId: "",
  });
  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [error, setError] = useState(null);
  const { stateAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [changedToggle, setChangedToggle] = useState(1);
  const [changedToggleLoading, setChangedToggleLoading] = useState("");
  let params = useParams();

  const loadPackagePlanPrice = (planId) => {
    const requestData = {
      id: planId,
    };
    setSelectedPlanId(planId);
    const getNaturePlanPriceItem = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      setLoading(true);
      setIsOpen(true);
      document.body.style.overflow = "hidden";
      try {
        const { data } = await getNaturePlanPriceItemService(
          requestData,
          header
        );

        setTour({
          AdultPrice: data.Value[0].AdultPrice,
          ChildPrice: data.Value[0].ChildPrice,
          DateTime: ConvertDate(data.Value[0].DateTime.slice(6, 19)).props
            .children,
          Load: data.Value[0].Load,
          State: data.Value[0].State,
          Description: data.Value[0].Description,
          CurrencyTypeId: data.Value[0].CurrencyTypeId,
        });
        setLoading(false);

        //formik.resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    getNaturePlanPriceItem();
  };

  const resetForNewPlan = () => {
    setTour({
      AdultPrice: "",
      ChildPrice: "",
      DateTime: "",
      Load: "",
      State: "",
      Description: "",
    });
    setSelectedPlanId("");
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  /*************** formik **************/
  const Currencyoptions = [
    { value: "7F242EBDC6E9405F9259D89C5FAD63C5", label: "ریال" },
  ];
  const PackagePublishState = [
    { value: 0, label: "فعال" },
    { value: 1, label: "غیر‌فعال" },
  ];

  const initialValues = {
    AdultPrice: tour.AdultPrice,
    ChildPrice: tour.ChildPrice,
    DateTime: tour.DateTime,
    Load: tour.Load,
    State:
      tour.State === 0 || tour.State === 1
        ? PackagePublishState[tour.State]
        : PackagePublishState[0],
    Description: btoa(tour.Description),
    CurrencyTypeId: "7F242EBDC6E9405F9259D89C5FAD63C5",
  };
  const validationSchema = Yup.object({
    Load: Yup.string().required("لطفا ظرفیت تور را وارد نمایید."),
    AdultPrice: Yup.string().required("لطفا قیمت بزرگسال را وارد نمایید."),
    ChildPrice: Yup.string().required("لطفا قیمت کودک را وارد نمایید."),
    DateTime: Yup.string().required(
      "لطفا تاریخ برگزاری تور خود را وارد نمایید."
    ),
    //State: Yup.object().required("لطفا وضعیت نمایش در سایت را مشخص کنید."),
  });

  const onSubmit = async (values) => {
    const packageId = params.id;
    const {
      AdultPrice,
      ChildPrice,
      Description,
      DateTime,
      State,
      Load,
      CurrencyTypeId,
    } = values;
    const userData = {
      // Id: selectedPlanId,
      AdultPrice,
      ChildPrice,
      Description: btoa(unescape(encodeURIComponent(Description))),
      DateTime,
      CurrencyTypeId,
      State: State.value,
      TourLeaderId: null,
      PackageId: packageId,
      Load,
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      const { data } = await SaveHikingTourPriceService(userData, header);
      setSubmitTracker(submitTracker + 1);
      document.body.style.removeProperty("overflow");
      toast.success(`قیمت و تاریخ برگزاری تور با موفقیت ثبت شد.`);
      setIsOpen(false);
      formik.resetForm();
      goToTop();
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        toast.error(error);
        goToTop();
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  const goNextStep = () => {
    nextStepTab();
  };
  const goPrevStep = () => {
    prevStepTab();
  };
  const closeModal = () => {
    setIsOpen(false);
    document.body.style.removeProperty("overflow");
  };

  const changeStateHandler = (event, id) => {
    console.log("event", event.target.checked);
    const isStateActive = event.target.checked;
    const requestData = {
      id: id,
    };
    setSelectedPlanId(id);
    setChangedToggleLoading(id);
    const getNaturePlanPriceItem = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await getNaturePlanPriceItemService(
          requestData,
          header
        );

        formik.setFieldValue("AdultPrice", data.Value[0].AdultPrice);
        formik.setFieldValue("ChildPrice", data.Value[0].ChildPrice);
        formik.setFieldValue(
          "DateTime",
          ConvertDate(data.Value[0].DateTime.slice(6, 19)).props.children
        );
        formik.setFieldValue("Load", data.Value[0].Load);
        formik.setFieldValue(
          "State",
          isStateActive ? { value: 0 } : { value: 1 }
        );
        formik.setFieldValue(
          "Description",
          btoa(unescape(encodeURIComponent(data.Value[0].Description)))
        );
        formik.setFieldValue("CurrencyTypeId", data.Value[0].CurrencyTypeId);
        setChangedToggle((prev) => prev + 1);
      } catch (error) {
        console.log(error);
      }
    };
    getNaturePlanPriceItem();
  };

  useEffect(() => {
    console.log("changedToggle", changedToggle);
    if (changedToggle > 1) formik.handleSubmit();
  }, [changedToggle]);

  return (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <div
            className={`animate__animated animate__fadeIn ${
              isOpen ? "relative z-20" : ""
            }`}
          >
            {isOpen && (
              <Modal setIsOpen={setIsOpen} sx={{ zIndex: "modal" }}>
                {!loading ? (
                  <form
                    className="flex flex-wrap justify-start items-start"
                    onSubmit={formik.handleSubmit}
                  >
                    <UpdateTourFormSecondStep
                      formik={formik}
                      Currencyoptions={Currencyoptions}
                      PackagePublishState={PackagePublishState}
                      descriptionValue={tour.Description}
                      DateValueValue={tour.DateTime}
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className="w-full flex justify-between px-3 mt-4">
                      <button
                        className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-red-600 text-white text-center rounded-md py-2 px-4"
                        onClick={closeModal}
                      >
                        انصراف
                      </button>
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="block w-24 mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
                      >
                        {formik.isSubmitting ? <Spinner /> : "ذخیره"}
                      </button>
                    </div>
                  </form>
                ) : (
                  <ContentLoading />
                )}
              </Modal>
            )}

            <div className="flex flex-wrap justify-start flex-col items-start px-3 md:px-0 mb-4">
              <NaturePlanPriceList
                PackageId={params.id}
                loadPackagePlanPrice={loadPackagePlanPrice}
                submitTracker={submitTracker}
                changeStateHandler={changeStateHandler}
                changedToggleLoading={changedToggleLoading}
                setChangedToggleLoading={setChangedToggleLoading}
              />
            </div>
            <div className={`flex px-3`}>
              <button
                className="mt-1 mb-4 mx-0 bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
                onClick={resetForNewPlan}
              >
                اضافه کردن
              </button>
            </div>
            <div className="w-full flex justify-between px-3">
              <div className="flex w-1/2 mt-2">
                <button
                  onClick={goPrevStep}
                  className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-red-400 text-white text-center rounded-md py-2 px-4"
                >
                  مرحله قبل
                </button>
              </div>
              <div className="flex w-1/2 justify-end gap-2 mt-2">
                <button
                  onClick={goNextStep}
                  className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
                >
                  ادامه
                </button>
              </div>
            </div>
          </div>
        )
      }
    </TrackVisibility>
  );
};

export default ManageTourThirdStep;
